import { CurrencyCode } from "../graphql/schema";

export interface MaybeUsUser {
  currency: { code: keyof typeof CurrencyCode };
}

export function isUserFromUs(user?: MaybeUsUser) {
  return user?.currency.code === "USD";
}
